import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StoreSelectionDialogDtComponent } from './dialogs/store-selection-dialog-dt.component';
import { DtDashboardService } from './dt-dashboard.service';
import { ConfirmDialogComponent } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-dt-dashboard',
    templateUrl: './dt-dashboard.component.html',
    styleUrls: ['./dt-dashboard.component.scss', '../dashboard.scss'],
    standalone: false
})

export class DtDashboardComponent implements OnInit {

    dashboardData: any;
    displayData: any;
    salesForcastAnnual: any;
    salesForcastWeekly: any;

    isLoading: boolean = true;
    GST_VALUE: any;
    targetImg: any;
    selectedShopName: string | null = null;
    selectedShopId: string | null = null;
    lastUpdatedMsg: string = '';
    userData: any;
    selectedStores: any = [];
    selectedStoresNames: any;
    includeSameStoreLY: any;
    constructor(private dashboardService: DtDashboardService, private dialog: MatDialog) { }

    ngOnInit(): void {
        const userDetailsData = sessionStorage.getItem('user');
        if (userDetailsData) {
            this.userData = JSON.parse(userDetailsData);
        }
        this.loadData();
    }

    buildParams(params?: any): any {
        // Default structure
        let payload: any = { shop_ids: [] };

        // Merge incoming params
        if (params) {
            if (params.shop_ids) payload.shop_ids = params.shop_ids;
            if (params.$multipleShop) payload.$multipleShop = params.$multipleShop;
            // Add other keys as needed
        }

        // If AREA_MANAGER and shop_ids is empty, use user_shops (array of objects)
        if (this.userData?.user_type === 'AREA_MANAGER' && Array.isArray(payload.shop_ids) && payload.shop_ids.length === 0) {
            if (Array.isArray(this.userData.user_shops)) {
                payload.shop_ids = this.userData.user_shops.map((shop: any) => shop.id);
            }
        }

        return payload;
    }

    loadData(params?: any) {
        this.isLoading = true;
        const payload = this.buildParams(params);
        this.dashboardService.getDashboardData(payload).subscribe({
            next: (response) => {
                this.dashboardData = response.data;
                this.isLoading = false;
                // -------Forecast Section-------
                const forcastPercentageAdjustmentAnnual = (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual ?? 0) * this.dashboardData?.sale_forcast_percentage) / 100);
                this.salesForcastAnnual = this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual + forcastPercentageAdjustmentAnnual;
                const forcastPercentageAdjustmentWeekly = (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly ?? 0) * this.dashboardData?.sale_forcast_percentage) / 100);
                this.salesForcastWeekly = this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly + forcastPercentageAdjustmentWeekly;
                // Set last updated message
                const timeDiff = this.dashboardData?.last_updated_diff;
                if (timeDiff < 1) {
                    this.lastUpdatedMsg = 'Last updated less than 1 min ago';
                } else {
                    this.lastUpdatedMsg = 'Last updated at ' + timeDiff + ' min ago';
                }
            },
            error: (err) => {
                this.isLoading = false;
                console.error('Dashboard API error', err);
            }
        });
    }

    onDashboardDataChange(newData: any) {
        this.dashboardData = newData;
        this.selectedShopName = newData.selectedShopName || null;
        this.selectedShopId = newData.selectedShopId || null;

        // Recalculate forecasts
        const forcastPercentageAdjustmentAnnual =
            (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual ?? 0) *
                this.dashboardData?.sale_forcast_percentage) /
                100);
        this.salesForcastAnnual =
            this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_annual +
            forcastPercentageAdjustmentAnnual;

        const forcastPercentageAdjustmentWeekly =
            (((this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly ?? 0) *
                this.dashboardData?.sale_forcast_percentage) /
                100);
        this.salesForcastWeekly =
            this.dashboardData?.dashboard_data_v3?.[0]?.sales_forcast_weekly +
            forcastPercentageAdjustmentWeekly;

        // Set selected shop name if present in newData
        if (newData?.selectedShopName) {
            this.selectedShopName = newData.selectedShopName;
        } else {
            this.selectedShopName = null;
        }
    }
    onBackToHQDashboard() {
        this.selectedShopId = null;
        this.selectedShopName = null;
        this.loadData();
    }
    onShopSelected(store: any) {
        this.selectedShopId = store.shopId;
        this.selectedShopName = store.name;
        // For single shop selection, use shop_id: [id]
        this.loadData({ shop_ids: [store.shopId] });

    }

    openStoreSelectionDialog() {
        let storesToShow = this.dashboardData?.shop_details || [];
        // If AREA_MANAGER, filter to only user_shops (array of objects), ensure type consistency and correct property
        // if (this.userData?.user_type === 'AREA_MANAGER' && Array.isArray(this.userData.user_shops)) {
        //     const userShopIds = this.userData.user_shops.map((shop: any) => Number(shop.id));
        //     storesToShow = storesToShow.filter((s: any) => userShopIds.includes(Number(s.id)));
        // }
        // console.log(storesToShow)
        const dialogRef = this.dialog.open(StoreSelectionDialogDtComponent, {
            width: '480px',
            minWidth: '330px',
            minHeight: '420px',
            data: {
                stores: storesToShow,
                selectedStoreIds: (this.selectedStores.length > 0
                    ? this.selectedStores
                    : storesToShow).map((s: any) => s.id),
                lastYearSameWeekSalesInfo: this.dashboardData?.lastYearSameWeekDtSalesInfo || {},
                includeSameStoreLY: this.includeSameStoreLY // <-- pass the current value
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.selectedStoreIds) {
                const allStores = this.dashboardData?.shop_details || [];
                this.selectedStores = allStores.filter((s: any) => result.selectedStoreIds.includes(s.id));
                // console.log(result.selectedStoreIds);
                // console.log(result.includeSameStoreLY);
                this.includeSameStoreLY = result.includeSameStoreLY;
                let shopIds = result.selectedStoreIds;
                // Print selected store names if present, otherwise print 'ALL'
                if (result.selectedStores && Array.isArray(result.selectedStores) && result.selectedStores.length > 0) {
                    this.selectedStoresNames = result.selectedStores.map((s: any) => s.name).join(', ');
                    // console.log('Selected Stores:', this.dashboardData?.shop_details);
                } else {
                    this.selectedStoresNames = 'ALL';
                }
                let payload: any = {};
                if (this.selectedStores.length === allStores.length) {
                    // All shops selected: empty shop_id array
                    payload.shop_ids = [];
                } else if (shopIds.length === 1) {
                    // Single shop selected
                    payload.shop_ids = [shopIds[0]];
                } else if (shopIds.length > 1) {
                    // Multiple shops selected
                    payload.shop_ids = shopIds;
                    payload.$multipleShop = true;
                }
                this.loadData(payload);
            }
        });
    }

        onRefresh() {
        // this.loadData({ shop_ids: [], refresh_data: 1 });
         const dialogRef = this.dialog.open(
                    ConfirmDialogComponent,
                    {
                        width: '350px',
                        data: {
                            title: 'Confirm Refresh',
                            message: "This may take few minutes to refresh all shop's data. Do you want to continue?",
                            yesButtonCaption: 'Yes',
                            noButtonCaption: 'Cancel',
                            showNoButton: true
                        }
                    }
                );
                dialogRef.afterClosed().subscribe(result => {
                    if (result === true) {
                        this.loadData({ shop_ids: [], refresh_data: 1 });
                    }
                });
    }

        printDashboard() {
        window.print();
    }
}

